module.exports = "/images/cu.jpg?f9d07f6563d9e385ff55f5d29ae5a3a3";